const BASE = '';

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  // Read as text first so a non-JSON body (an HTML error page from CloudFront, or an API
  // mid-deploy) produces a readable error instead of "Unexpected token '<'".
  const text = await res.text();
  let data: any = null;
  if (text) { try { data = JSON.parse(text); } catch { /* non-JSON */ } }
  if (!res.ok) {
    const err = new Error((data && data.error) || `Request failed: ${res.status}`);
    (err as any).status = res.status;
    throw err;
  }
  return data as T;
}

export interface User { email: string; name: string }

export const getMe = () => request<User>('/api/me');
export const logout = () => request<{ success: boolean }>('/api/logout', { method: 'POST' });

export interface FixtureClient { id: number; name: string }
export interface DayFixture {
  id: number;
  gameId: string;
  providerCompetitionId: string;
  seasonId: string;
  matchDate: string;
  matchTime: string | null;
  matchDateUtc: string | null;
  matchStatus: string;
  venue: string | null;
  matchDay: number | null;
  homeTeamId: string;
  awayTeamId: string;
  homeTeamName: string | null;
  awayTeamName: string | null;
  homeScore: number | null;
  awayScore: number | null;
  homePenaltyScore: number | null;
  awayPenaltyScore: number | null;
  homeClients: FixtureClient[];
  awayClients: FixtureClient[];
  isClientFixture: boolean;
}
export interface DayCompetition {
  providerCompetitionId: string;
  name: string;
  typeName: string | null;
  displayOrder: number | null;
  fixtures: DayFixture[];
}
export interface FixturesDay {
  date: string;
  scope: 'clients' | 'all';
  competitions: DayCompetition[];
  clientFixtureCount: number;
  totalFixtureCount: number;
}

export const getFixturesByDay = (date: string, scope: 'clients' | 'all') =>
  request<FixturesDay>(`/api/fixtures/day?date=${date}&scope=${scope}`);

/**
 * How many client fixtures fall on each day of a range, for the markers on the date
 * strip. Sparse: a date with none is simply absent from `days`.
 */
export interface ClientDays {
  from: string;
  to: string;
  days: Record<string, number>;
}

export const getClientDays = (from: string, to: string) =>
  request<ClientDays>(`/api/fixtures/client-days?from=${from}&to=${to}`);
